
export enum SubscriptionBadgeType {
  Free = 'Free',
  Standard = 'Standard',
  Premium = 'Premium',
}
